import { TApplicationState } from '../../types/redux';

export const selectJsonQuery = (state: TApplicationState) => {
  return state.jsonQuery;
};
